import {
  GET_EVENTS_SUCCESS,
  GET_EVENTS_FAIL,
  ADD_EVENT_SUCCESS,
  ADD_EVENT_FAIL,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAIL,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAIL,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAIL,
  SET_PAGE_DATA,
  SET_CANDIDATE_SIDEBAR_VISIBLE,
  SET_JOB_SIDEBAR_VISIBLE,
  SET_CONTACT_SIDEBAR_VISIBLE,
  SET_COMPANY_SIDEBAR_VISIBLE
} from "./actionTypes"

const INIT_STATE = {
  events: [],
  categories: [],
  visible: false,
  jobSidebarVisible: false,
  contactSidebarVisible: false,
  companySidebarVisible: false,
  error: {},
  pagination: {
    first: 0,
    rows: 10,
    totalRecords: 20,
  },
}

const Calendar = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EVENTS_SUCCESS:
      return {
        ...state,
        events: action.payload,
      }
    case GET_EVENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_EVENT_SUCCESS:
      return {
        ...state,
        events: [...state.events, action.payload],
      }

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_EVENT_SUCCESS:
      return {
        ...state,
        events: state.events.map(event =>
          event.id.toString() === action.payload.id.toString()
            ? { event, ...action.payload }
            : event
        ),
      }

    case UPDATE_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_EVENT_SUCCESS:
      return {
        ...state,
        events: state.events.filter(
          event => event.id.toString() !== action.payload.id.toString()
        ),
      }

    case DELETE_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload,
      }

    case GET_CATEGORIES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case SET_PAGE_DATA:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          first: action.payload.first,
          rows: action.payload.rows,
          totalRecords: action.payload.totalRecords,
        },
      }
    case SET_CANDIDATE_SIDEBAR_VISIBLE:
      return { ...state, visible: action.payload };
    case SET_JOB_SIDEBAR_VISIBLE:
      return { ...state, jobSidebarVisible: action.payload };
    case SET_CONTACT_SIDEBAR_VISIBLE:
      return { ...state, contactSidebarVisible: action.payload };
    case SET_COMPANY_SIDEBAR_VISIBLE:
      return { ...state, companySidebarVisible: action.payload };
    default:
      return state
  }
}

export default Calendar
